import * as R from "ramda";
import PORTFOLIO_RULE_NAMES from "./../PortfolioRuleNames.js";

export default function(portfolioRules) {
    const isAnInvestmentRule = rule => {
        return R.contains(rule.name, R.values(PORTFOLIO_RULE_NAMES));
    };

    return portfolioRules.filter(isAnInvestmentRule);
}